const SPORT_ROOT_REGEX = /^(?:\/([^/]+))?\/sport\/root\/(.+)$/
const BETBY_ROOT_REGEX = /^\/root\/(.+)$/

export function getBetbyRootRedirect(betbyPath: string): null | string {
  const matched = betbyPath.match(BETBY_ROOT_REGEX)
  if (!matched) {
    return null
  }

  const target = matched?.[1]?.replace(/^\/+/, '')
  return target ? `/${target}` : null
}

export function getSportRootRedirect(path: string, availableLocale: string[]): null | string {
  const matched = path.match(SPORT_ROOT_REGEX)
  if (!matched) {
    return null
  }

  const [, localeCode, rest] = matched
  if (localeCode && !availableLocale.includes(localeCode)) {
    return null
  }

  const target = rest?.replace(/^\/+/, '')
  if (!target) {
    return null
  }

  return `${localeCode ? `/${localeCode}` : ''}/${target}`
}
